import React, { useEffect, useState } from "react";
import AddKarnetModal from "./AddKarnetModal";
import EditNoteModal from "./EditNoteModal";
import EditUserModal from "./EditUserModal";
import axios from "axios";

const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditNoteModalOpen, setIsEditNoteModalOpen] = useState(false);
  const [isEditUserModalOpen, setIsEditUserModalOpen] = useState(false);
  const [selectedUserForEdit, setSelectedUserForEdit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const usersPerPage = 10;
  const token = localStorage.getItem("token"); // Pobierz token z localStorage

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    setFilteredUsers(
      users.filter((user) =>
        `${user.imie} ${user.nazwisko}`
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      )
    );
    setCurrentPage(1);
  }, [searchQuery, users]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BACKEND_URL}/api/user/getAllUsers`,
      {headers: {
        Authorization: `Bearer ${token}`
      }}
    );
      setUsers(response.data);
      setFilteredUsers(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error.message);
      setError("Błąd podczas pobierania użytkowników");
      setLoading(false);
    }
  };

  const handleEdit = (user) => {
    setSelectedUserForEdit(user);
    setIsEditUserModalOpen(true);
  };

  const handleAddNote = (user) => {
    setSelectedUserForEdit(user);
    setIsEditNoteModalOpen(true);
  };

  const handleAddKarnetClick = (userId) => {
    setSelectedUser(userId);
  };

  const handleCloseModal = () => {
    setSelectedUser(null);
  };

  const handleSaveNote = async (newNote) => {
    try {
      await axios.put(
        `${BACKEND_URL}/api/user/updateUser/${selectedUserForEdit._id}`,
        { notatka: newNote },
        {headers: {
          Authorization: `Bearer ${token}`
        }}
      );
      setIsEditNoteModalOpen(false);
      fetchUsers();
    } catch (error) {
      console.error("Error updating note:", error.message);
    }
  };

  const handleSaveUser = async (updatedUserData) => {
    try {
      await axios.put(
        `${BACKEND_URL}/api/user/updateUser/${selectedUserForEdit._id}`,
        updatedUserData,
        {headers: {
          Authorization: `Bearer ${token}`
        }}
      );
      setIsEditUserModalOpen(false);
      fetchUsers();
    } catch (error) {
      console.error("Error updating user:", error.message);
    }
  };

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  const currentUsers = filteredUsers.slice(
    (currentPage - 1) * usersPerPage,
    currentPage * usersPerPage
  );

  if (loading)
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-xl text-gray-600">Ładowanie użytkowników...</div>
      </div>
    );

  if (error)
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-xl text-red-600">{error}</div>
      </div>
    );

  return (
    <div className="p-4 max-w-6xl mx-auto bg-white rounded-lg shadow-lg">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold text-gray-800">
          Wszyscy Użytkownicy
        </h1>
        <input
          type="text"
          placeholder="Szukaj użytkownika..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="border border-gray-300 rounded-lg p-2 w-64 focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border-collapse">
          <thead>
            <tr className="bg-gray-100">
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Imię i Nazwisko
              </th>
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Email
              </th>
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Telefon
              </th>
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Data urodzenia
              </th>
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Notatka
              </th>
              <th className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Aktywny
              </th>
              <th className="border-b px-4 py-2 text-center text-sm font-semibold text-gray-700">
                Akcje
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {currentUsers.map((user) => (
              <tr key={user._id} className="hover:bg-gray-50">
                <td className="px-4 py-2">
                  <div className="font-medium">
                    {user.imie} {user.nazwisko}
                  </div>
                </td>
                <td className="px-4 py-2">{user.email}</td>
                <td className="px-4 py-2">{user.telefon}</td>
                <td className="px-4 py-2">
                  {new Date(user.urodziny).toLocaleDateString("pl-PL")}
                </td>
                <td className="px-4 py-2">
                  <div className="max-w-xs truncate">{user.notatka}</div>
                </td>
                <td className="px-4 py-2 text-center">
                  {user.aktywny ? "Tak" : "Nie"}
                </td>
                <td className="px-4 py-2">
                  <div className="flex justify-center space-x-1">
                    <button
                      onClick={() => handleEdit(user)}
                      className="p-1 rounded-md hover:bg-gray-100"
                      title="Edytuj dane"
                    >
                      <svg
                        className="w-5 h-5 text-blue-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                    </button>
                    <button
                      onClick={() => handleAddNote(user)}
                      className="p-1 rounded-md hover:bg-gray-100"
                      title="Dodaj notatkę"
                    >
                      <svg
                        className="w-5 h-5 text-yellow-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                    </button>
                    <button
                      onClick={() => handleAddKarnetClick(user._id)}
                      className="p-1 rounded-md hover:bg-gray-100"
                      title="Dodaj karnet"
                    >
                      <svg
                        className="w-5 h-5 text-green-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 4v16m8-8H4"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginacja */}
      <div className="flex justify-between items-center mt-4">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="px-3 py-1 rounded-lg bg-blue-500 text-white text-sm disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          ← Poprzednia
        </button>
        <span className="text-sm text-gray-600">
          Strona {currentPage} z {totalPages || 1}
        </span>
        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages || totalPages === 0}
          className="px-3 py-1 rounded-lg bg-blue-500 text-white text-sm disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          Następna →
        </button>
      </div>

      {/* Modale */}
      {selectedUser && (
        <AddKarnetModal
          userId={selectedUser}
          onClose={handleCloseModal}
          onKarnetAdded={(newKarnet) => {
            handleCloseModal();
          }}
        />
      )}

      {isEditNoteModalOpen && (
        <EditNoteModal
          isOpen={isEditNoteModalOpen}
          onClose={() => setIsEditNoteModalOpen(false)}
          user={selectedUserForEdit}
          onSave={handleSaveNote}
        />
      )}

      {isEditUserModalOpen && (
        <EditUserModal
          isOpen={isEditUserModalOpen}
          onClose={() => setIsEditUserModalOpen(false)}
          user={selectedUserForEdit}
          onSave={handleSaveUser}
        />
      )}
    </div>
  );
};

export default AllUsers;
